"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setDefaultConfig = exports.defaultGetPrefixCls = exports.defaultGetPopupContainer = exports.defaultGetIconPrefixCls = exports.ConfigContext = void 0;
var _react = _interopRequireDefault(require("react"));
var _typeof = require("../utils/data/typeof");
var defaultPrefixCls = 'mtd-prime';
var defaultIconPrefixCls = 'mtd-prime-icon';
var defaultPopupContainer = document.body;
var defaultGetPrefixCls = exports.defaultGetPrefixCls = function defaultGetPrefixCls(suffixCls, customizePrefixCls) {
  if (customizePrefixCls) return customizePrefixCls;
  return suffixCls ? "".concat(defaultPrefixCls, "-").concat(suffixCls) : defaultPrefixCls;
};
var defaultGetIconPrefixCls = exports.defaultGetIconPrefixCls = function defaultGetIconPrefixCls(customizeIconPrefixCls) {
  if (customizeIconPrefixCls) return customizeIconPrefixCls;
  return defaultIconPrefixCls;
};
var defaultGetPopupContainer = exports.defaultGetPopupContainer = function defaultGetPopupContainer() {
  return defaultPopupContainer;
};
// zombieJ: 🚨 Do not pass `defaultRenderEmpty` here since it will cause circular dependency.
var ConfigContext = exports.ConfigContext = /*#__PURE__*/_react.default.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  getIconPrefixCls: defaultGetIconPrefixCls,
  getPopupContainer: defaultGetPopupContainer
});
var setDefaultConfig = exports.setDefaultConfig = function setDefaultConfig(config) {
  if ((0, _typeof.isDefinedAndNotNull)(config.prefixCls)) {
    defaultPrefixCls = config.prefixCls;
  }
  if ((0, _typeof.isDefinedAndNotNull)(config.iconPrefixCls)) {
    defaultIconPrefixCls = config.iconPrefixCls;
  }
  if ((0, _typeof.isDefinedAndNotNull)(config.getPopupContainer)) {
    defaultPopupContainer = config.getPopupContainer();
  }
};